import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { ProductType, ProductTypes } from '../../model/product/product-type';
import Windowsticker from '../../model/product/windowsticker/windowsticker';
import Product from '../../model/product/product';
import CustomWindowsticker from '../../model/product/windowsticker/custom-windowsticker';
import PMSColor from 'src/app/model/company/pmscolor';
import { Subject } from 'rxjs';
import WindowStickerPlacement from 'src/app/model/product/windowsticker/windowsticker-placement';
import Company from 'src/app/model/company/company';
import Board from 'src/app/model/product/board/board';
import BoardPlacement from 'src/app/model/product/board/board-placement';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import OtherProductPlacement from 'src/app/model/product/other-product/other-product-placement';

@Component({
  selector: 'product-picker',
  templateUrl: './product-picker.component.html',
  styleUrls: ['./product-picker.component.scss'],
})
export class ProductPickerComponent<T extends Product> implements OnInit {
  projectOptions: ProductType[];
  productType: String;

  @Input()
  public index = 0;
  @Input()
  public inputProject: Project;
  @Input()
  public inputProduct: T;
  @Input()
  public involvedCompanies: Company[];
  @Input()
  public pmsColorAdded: Subject<PMSColor>;
  @Input()
  public standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent>;
  @Input()
  public client = false;
  @Input()
  public fromOldSystem = false;
  @Input()
  public disabled = false;
  @Input()
  public isCollapsed = true;
  @Output()
  public updateProject = new EventEmitter();
  @Output()
  public typeWasSelected = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.projectOptions = [
      ProductTypes.WINDOWSTICKER,
      ProductTypes.CUSTOMWINDOWSTICKER,
      ProductTypes.BOARD,
      ProductTypes.OTHER_PRODUCT,
    ];
  }

  selectType(type: ProductType) {
    let product;
    switch (type) {
      case ProductTypes.WINDOWSTICKER:
        product = new Windowsticker();
        product.productPlacement = new WindowStickerPlacement();
        product.productPlacement.productPlacementType =
          'WindowStickerPlacement';
        break;
      case ProductTypes.CUSTOMWINDOWSTICKER:
        product = new CustomWindowsticker();
        product.productPlacement = new WindowStickerPlacement();
        product.productPlacement.productPlacementType =
          'WindowStickerPlacement';
        break;
      case ProductTypes.BOARD:
        product = new Board();
        const boardPlacement = new BoardPlacement();
        boardPlacement.productPlacementType = 'BoardPlacement';
        product.productPlacement = boardPlacement;
        product.boardConstructionMaterials = [];
        break;
      case ProductTypes.OTHER_PRODUCT:
        product = new OtherProduct();
        product.productPlacement = new OtherProductPlacement();
        product.productPlacement.productPlacementType = 'OtherProductPlacement';
    }
    let productIndex = this.inputProject.products.indexOf(this.inputProduct);
    this.inputProject.products[productIndex] = product;
    this.updateProject.emit();
    this.typeWasSelected.emit();
  }

  getTypeExists() {
    if (this.inputProduct != null) {
      if (this.inputProduct.type != null) {
        return true;
      }
    }
    return false;
  }
}
